import React from 'react'
import Img from 'gatsby-image'

import "../styles/roster-card.scss"

const RosterCard = (props) => {
    return (
        <div className={`player-card ${props.shaded}`}>
            <div className="player-img">
                <Img className="img" fluid={props.img} alt={props.name} imgStyle={{objectFit: "contain"}} />
            </div>
            <div className="player-information-container">
                    
                <div className="player-name">
                    <span>{props.number}</span> {props.name}
                </div> 
                <div classname="player-info">
                    <div className="player-position">{props.position}</div>
                    <p>Class of {props.class}</p>
                </div>
            </div>
            {/* <div className="player-img">
                <Img className="img" fluid={props.img} alt={props.name} imgStyle={{objectFit: "contain"}} />
            </div>
            <div className="player-content">
                <div className="player-name">
                    <span>{props.number}</span> {props.name}
                </div>
                <div classname="player-info">
                    <p><b>{props.position}</b> / {props.team}</p>
                    <p>Class of {props.class}</p>
                </div>
            </div> */}
        </div>
    )
}

export default RosterCard
